/**
 * Utility function to export data to CSV format
 * @param {Array} data - Array of objects to export
 * @param {string} filename - Name of the CSV file (without extension)
 * @param {Array} headers - Array of header objects with label and key properties
 */
export const exportToCSV = (data, filename, headers) => {
  if (!data || data.length === 0) {
    console.warn("No data to export");
    return;
  }

  // Create CSV content
  const csvContent = [
    // Headers row
    headers.map((header) => `"${header.label}"`).join(","),
    // Data rows
    ...data.map((row) =>
      headers
        .map((header) => {
          const value = getNestedValue(row, header.key);
          // Escape quotes and wrap in quotes if contains comma, newline, or quote
          const escapedValue = String(value || "").replace(/"/g, '""');
          return `"${escapedValue}"`;
        })
        .join(",")
    ),
  ].join("\n");

  // Create and download file
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

/**
 * Helper function to get nested object values using dot notation
 * @param {Object} obj - The object to search in
 * @param {string} path - The path to the value (e.g., 'user.name')
 * @returns {*} The value at the path or undefined
 */
const getNestedValue = (obj, path) => {
  return path.split(".").reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : "";
  }, obj);
};
